<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    fullscreen
    :before-close="close">
    <div class="display-flex jc-center ai-center height-percent-100">
      <div class="content scrollbar-y">
        <header class="mr-26">
          <h2 class="mt-0">试卷标题</h2>
          <p>试卷分数：{{count}}</p>
        </header>
        <el-scrollbar style="height: calc(100% - 80px);">
          <div class="fs-16 mr-26">
            <div v-for="(item, index) in questionList" :key="item.id" class="pb-10">
              <p class="mt-0 pt-14">{{index+1}}. {{item.title}}</p>
              <el-input
                v-if="item.componentType === 'message'"
                placeholder="请输入"
                type="textarea"
                autosize
                v-model="item.answer"
                size="small"
                class="width-percent-100"></el-input>
              <div v-for="i in item.options" :key="i.value" class="display-flex ai-center jc-space-between mt-12 ml-2">
                <el-checkbox v-if="item.componentType === 'duoxuan'" v-model="item.answer" :label="i.value" class="width-percent-40">{{ i.label }}</el-checkbox>
                <el-radio v-else v-model="item.answer" :label="i.value" class="mr-0 width-percent-40">{{ i.label }}</el-radio>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExamPreview',
  components: {},
  props: {
    title: {
      type: String,
      default () {
        return '预览'
      }
    },
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    defaultQuestionList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      questionList: []
    }
  },
  filters: {},
  computed: {
    count () {
      let count = 0
      for (const item of this.questionList) {
        count += item.score || 0
      }
      return count
    }
  },
  watch: {},
  methods: {
    close () {
      this.$emit('close')
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.questionList = this.defaultQuestionList
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__body {
    padding: 0;
    height: calc(100vh - 60px);
    background-color: #F3F3F5;
  }
  .content {
    height: calc(100% - 80px);
    padding: 20px 14px 20px 40px;
    width: 60%;
    background-color: #FFFFFF;
    header {
      border-bottom: 2px solid #54A4F4;
    }
  }
</style>
